import { onInstallService, useOnReinstall } from './handlers/install'

const CLIENT_ID = '286590345586-2v0mjgrttgnvndr8791fi4h61bbg62ur.apps.googleusercontent.com'

export const GOOGLE_CALENDAR = {
  CLIENT_ID,
  REDIRECT_URI: `${process.env.REACT_APP_BASE_DOMAIN}/middleware/integrations/google`,
  onInstall: onInstallService,
  onReinstall: useOnReinstall,
  SCOPE: [
    `openid`,
    `email`,
    `profile`,
    `https://www.googleapis.com/auth/calendar`,
    `https://www.googleapis.com/auth/admin.directory.user.readonly`
  ]
}

export default GOOGLE_CALENDAR
